import React, { useEffect, useState } from 'react';
import { useFormikContext, Field } from 'formik';

import { joinClassNames } from '../../../utils/joinClassNames';
import { useSearchFormContext } from '../../../context/SearchFormContext';
import Suggestions from '../../organisms/Suggestions/Suggestions';
import useDebouncedInput from '../../../utils/debounceInput';
import { useSearchQuestion } from '@context/DataContext';

const QueryField = () => {
  const { values, resetForm, submitForm, setFieldValue } = useFormikContext();
  const { query } = useSearchFormContext();
  const { setSuggestQuery, setShowSuggestions, setSuggestResponse } = useSearchQuestion();
  const [debounceDelay, setDebounceDelay] = useState(0);

  const { id, label, placeholder, type } = query;

  const optionalPropDefs = {
    id,
    placeholder,
  };
  const optionalProps = {};
  Object.keys(optionalPropDefs).forEach((prop) => {
    const propValue = optionalPropDefs[prop];
    if (propValue) {
      optionalProps[prop] = propValue;
    }
  });

  const handleClear = () => {
    resetForm({ values: { query: '' } });
    setSuggestResponse([]);
    setShowSuggestions(false);
    submitForm();
  };

  // debounce the query test and ping suggestions
  const [queryText, setQueryTextDebounced] = useDebouncedInput({ debounceTime: debounceDelay });
  useEffect(() => {
    if (queryText.length > 2) {
      setSuggestQuery(queryText);
      setShowSuggestions(true);
    } else {
      setSuggestQuery(false);
      setShowSuggestions(false);
    }
  }, [queryText]);

  const clickHandler = (obj) => {
    setShowSuggestions(false);
    setFieldValue('query', obj);
    submitForm();
  };

  return (
    <>
      <div className="module-search__group">
        <Field
          type={type}
          name="query"
          aria-label={label}
          value={values.query}
          autoComplete={'off'}
          {...optionalProps}
          className={joinClassNames(['form-control', 'query'])}
          onChange={(e) => {
            if (e.target.value > 1) {
              setDebounceDelay(750);
            } else {
              setDebounceDelay(0);
            }
            setQueryTextDebounced(e.target.value);
            setFieldValue('query', e.target.value);
          }}
          onFocus={() => {
            setShowSuggestions(true);
          }}
        />
        <button type="submit" className={joinClassNames(['btn', 'search'])}>
          <svg className="icon icon-search" viewBox="0 0 27 28" fill="none">
            <circle cx="11.12" cy="10.64" r="9.12" stroke="#333333" strokeWidth="2.5" />
            <path d="M17.726 18.2062L25.7039 26.184" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          <span className="sr-only">Search</span>
        </button>

        <button type="button" aria-label="Clear search" className="btn clear-search" onClick={handleClear}>
          <svg className="icon icon-clear-search" viewBox="0 0 34 34" fill="none">
            <rect x="7.60132" y="24.5425" width="24" height="2" transform="rotate(-45 7.60132 24.5425)" fill="#333333" />
            <rect x="24.5721" y="26.4277" width="24" height="2" transform="rotate(-135 24.5721 26.4277)" fill="#333333" />
          </svg>
          <span className="sr-only">Clear search</span>
        </button>

        <Suggestions clickHandler={clickHandler} />
      </div>
    </>
  );
};

export default QueryField;
